import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import CustomInputField from "../../../../components/common/CustomInputField";
import { useSelector, useDispatch } from "react-redux";
import Required from "../../../../components/Required";
import ReactTooltip from "react-tooltip";
import { getCompanySize } from "../../../../api/User/Hub/companysetupApi";
import { GetIndrDetails } from "../../../../api/User/ACG/IndrApi";
import { GetFundingDetails } from "../../../../api/User/ACG/FundingApi";
import {
  GetBenchmark,
  GetClientsDataByClientID,
  GetCommissionRateByGroupSizeZipCode,
  UpdateClientsDetails,
  GetApprovedRegionsByUDid,
} from "../../../../api/User/ACG/clientDeatilApi";
import ReactSelect from "react-select";
import { getCarrier } from "../../../../api/Admin/carrierApi";
import toastFile from "../../../../Service/ToastFile";
import moment from "moment";
import { selectedClientData } from "../../../../Redux/Reducer/ClientDataReducer";

const schema = Yup.object().shape({
  Client_Name: Yup.string()
    .max(100, "Client name not more then 100 charater")
    .required("Please enter client name"),
  Renewal_Date: Yup.string().required("Please enter renewal date"),
  Main_Carriers: Yup.array()
    .min(1, "Please select main carriers")
    .required("Please enter main carriers"),
  zip: Yup.string().required("Please enter zip"),
  Group_Size: Yup.string()
    .notOneOf(["Select Group Size"], "Please select group size")
    .test(
      "is-aligned",
      "The Group Size is not aligned with # of Eligible Employees",
      function (value) {
        const numberOfEmployees = this.resolve(Yup.ref("Eligible_EEs_CT"));
        if (
          (+numberOfEmployees <= 500 && value !== "Small") ||
          (+numberOfEmployees >= 501 &&
            +numberOfEmployees <= 1000 &&
            value !== "Mid") ||
          (+numberOfEmployees >= 1001 &&
            +numberOfEmployees <= 4999 &&
            value !== "Large") ||
          (+numberOfEmployees >= 5000 && value !== "Jumbo")
        ) {
          return false;
        }
        return true;
      }
    )
    .required("Please select group size"),
  Industry: Yup.string()
    .notOneOf(["Select Industry"], "Please select industry")
    .required("Please select industry"),

  Eligible_EEs_CT: Yup.number()
    .integer("Value must be an integer")
    .typeError("Please enter a valid number")
    .test(
      "is-aligned",
      "The # of Eligible Employees is not aligned with selected Groups Size",
      function (value) {
        const Group_Size = this.resolve(Yup.ref("Group_Size"));
        if (Group_Size === "Small" && (value < 1 || value > 500)) {
          return false;
        } else if (Group_Size === "Mid" && (value < 501 || value > 1000)) {
          return false;
        } else if (Group_Size === "Large" && (value < 1001 || value > 4999)) {
          return false;
        } else if (Group_Size === "Jumbo" && value < 5000) {
          return false;
        }
        return true;
      }
    )
    .required("Please enter Eligible_EEs_CT"),
  Enrolled_EEs_CT: Yup.number()
    .integer("Value must be an integer")
    .typeError("Please enter a valid number")
    .required("Please enter Enrolled_EEs_CT"),
  Waived_EEs_CT: Yup.number()
    .integer("Value must be an integer")
    .typeError("Please enter a valid number")
    .required("Please enter Waived_EEs_CT"),
  Enrolled_Mbrs_Ct: Yup.number()
    .integer("Value must be an integer")
    .typeError("Please enter a valid number")
    .required("Please enter Enrolled_Mbrs_Ct"),
  ISL_Pooling_Point: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ISL_Pooling_Point")
});

const ClientDetail = ({
  showForm,
  setShowForm,
  isEdit,
  setIsEdit,
  isAdd,
  setIsAdd,
  setSelectedClientValue,
}) => {
  const dispatch = useDispatch();
  const client = useSelector((state) => state.clientData.value);
  const user = useSelector((state) => state.userDetails.value);
  const [selectClientData, setSelectClientData] = useState({});
  const [weightDropdown, setWeightDropdown] = useState({
    medical: Array.from({ length: 101 }, (_, index) => index),
    pharmacy: Array.from({ length: 101 }, (_, index) => index),
  });
  const [isDisabled, setIsdisabled] = useState(false);
  const [dropdownData, setDropdownData] = useState({
    GroupSizeData: [],
    IndustryData: [],
    FundingArrangementData: [],
    carrierData: [],
  });
  const [showModal, setShowModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [regionData, setRegionData] = useState([]);

  useEffect(() => {
    getCompanySizeList();
    getFundingList();
    getIndustryRiskData();
    getCarrierData();
    getRegion();
  }, []);
  useEffect(() => {
    if (!isAdd) {
      setShowForm(true);
      setSelectClientData({});
      setWeightDropdown({
        medical: Array.from({ length: 101 }, (_, index) => index),
        pharmacy: Array.from({ length: 101 }, (_, index) => index),
      });
    } else {
      // getClientData(client.clientID)
    }
  }, [isAdd]);

  useEffect(() => {
    if (client !== null && client?.clientID !== 0) {
      setShowForm(false);
      getClientData(client?.clientID);
    }
    return () => {
      setShowForm(false);
      setIsEdit(true);
    };
  }, [client]);

  const getClientData = async (ID) => {
    await GetClientsDataByClientID(user?.UD_id, ID).then((res) => {
      if (res.status === 200) {
        if (res.data.length) {
          let data = res.data[0];
          setSelectClientData(data);
          setWeightDropdown({
            medical: Array.from(
              { length: 101 - data.PharmacyWeight },
              (_, index) => index
            ),
            pharmacy: Array.from(
              { length: 101 - data.MedicalWeight },
              (_, index) => index
            ),
          });
        } else {
          setSelectClientData({});
        }
        setShowForm(true);
      }
    });
  };

  const getRegion = () => {
    GetApprovedRegionsByUDid(user.UD_id).then((res) => {
      setRegionData(res.data);
    });
  };

  const getCarrierData = () => {
    getCarrier().then((res) => {
      if (res.status === 200) {
        res.data.sort((a, b) => a.CarrierName.localeCompare(b.CarrierName));
        let formatedData = res.data.map((obj) => {
          return { value: obj.CarrierName, label: obj.CarrierName };
        });
        setDropdownData((prev) => ({ ...prev, carrierData: formatedData }));
      } else {
        // console.log(res.response.statusText);
      }
    });
  };

  const getIndustryRiskData = () => {
    GetIndrDetails()
      .then((res) => {
        setDropdownData((prev) => ({ ...prev, IndustryData: res.data }));
      })
      .catch((err) => console.log({ err }));
  };

  const getCompanySizeList = () => {
    getCompanySize().then((res) => {
      setDropdownData((prev) => ({
        ...prev,
        GroupSizeData: res.data.map((item) => ({
          ...item,
          value: item.CompanySizeName.split(" ")[0],
        })),
      }));
    });
  };

  const getFundingList = () => {
    GetFundingDetails()
      .then((res) => {
        setDropdownData((prev) => ({
          ...prev,
          FundingArrangementData: res.data,
        }));
      })
      .catch((err) => console.log({ err }));
  };

  const handleActions = async (values, handlre) => {
    setConfirm(false);
    if (!isAdd && values.hubLocalRegion === "") {
      toastFile("Please select Region");
      return;
    }
    if (
      !confirm &&
      (values.ISL_Pooling_Point === "0" ||
        values.ISL_Pooling_Point === "" ||
        values.ISL_Pooling_Point === undefined)
    ) {
      setShowModal(true);
      return;
    }

    let payload = {
      clientID: !isAdd ? 0 : client?.clientID,
      userID: user?.UD_id,
      regionID: !isAdd ? +values.hubLocalRegion : client?.regionId,
      zipCode: "",
      sicCode: "",
      industryID: 0,
      companySizeID: 0,
      producer: values?.Producer,
      eligible_EEs_CT: +values.Eligible_EEs_CT,
      renewal_Date: values.Renewal_Date,
      funding_Arrangement:
        values?.Funding_Arrangement !== "Select Funding Arrangement"
          ? +values?.Funding_Arrangement
          : 0,
      commission_Rate: 0,
      commission_Override: "No",
      client_Contact_Name: "",
      phone: "",
      enrolled_Mbrs_Ct: +values.Enrolled_Mbrs_Ct,
      enrolled_Kaiser_Mbrs_CT: 0,
      enrolled_EEs_CT: +values.Enrolled_EEs_CT,
      kaiser_EEs_CT: 0,
      industry: values?.Industry !== "Select Industry" ? values?.Industry : "",
      email_Phone: "",
      email: "",
      waived_EEs_CT: +values.Waived_EEs_CT,
      isL_Pooling_Point: +values.ISL_Pooling_Point,
      group_Size:
        values?.Group_Size !== "Select Group Size" ? values?.Group_Size : "",
      bill_Office: 0,
      irmI_LC_Benchmark: +values.IRMI_LC_Benchmark,
      main_Carriers: values?.Main_Carriers.map((item) => item.value).join(","),
      add_Inflation_to_ACG: "No",
      medical_Inflation_Rate:0,
      ex_Inflation_Rate: 0.00,
      user_Created: user?.UD_id,
      zip: values?.zip,
      hiT_Tax_Included:"No",
      hiT_Tax_Rate: 0,
      createdBy: user?.UD_id,
      isCensusProgress: 1,
      medicalTrend: 0,
      medicalWeight: 50,
      pharmacyTrend: 0,
      pharmacyWeight: 50,
      irmI_Benchmark_Values: "Expected",
      clientName: !isAdd
        ? values.Client_Name.trimEnd().replace(/\s+/g, " ")
        : values.Client_Name,
      clientDBA: !isAdd
        ? values.Client_Name.trimEnd().replace(/\s+/g, " ")
        : values.Client_Name,
      siC_Sub_Industry: !isAdd ? "0" : client.siC_Sub_Industry,
      contactID: 0,
      clientZipCode: values?.zip,
    };
    // console.log(payload)
    UpdateClientsDetails(payload).then((res) => {
      if (res?.code === "ERR_BAD_REQUEST") {
        if (res.response.data === "Client is already exists.") {
          toastFile(res.response.data);
        } else {
          toastFile("Request failed");
        }
      } else if (res.status === 200) {
        if (!isEdit) {
          getClientData(client.clientID);
          toastFile("Client Updated Successfully", "success");
        } else {
          let clientobj = {
            clientID: res.data,
            clientName: values.Client_Name.trimEnd().replace(/\s+/g, " "),
            uD_id: user.UD_id,
            iA_Id: res.data,
            regionId: +values.hubLocalRegion,
            siC_Sub_Industry: "0",
            industryID: 0,
            companySizeID: 0,
            ahI_Industry: "",
            ahI_CompanyGroupSize: "",
            clientZipCode:values?.zip
          };
          dispatch(selectedClientData(clientobj));
          toastFile("Client Saved Successfully", "success");
        }
        setShowForm(false);
        setIsAdd(true);
        setIsEdit(true);
      }
    });
  };

  const setBenchMark = (payload, set, values, inc) => {
    const Eligible_EEs_CT = Number(values.Eligible_EEs_CT);
    const ISL_Pooling_Point = Number(values.ISL_Pooling_Point);
    GetBenchmark(payload).then((res) => {
      if (res.data === "Not Found" || ISL_Pooling_Point === 0) {
        set("IRMI_LC_Benchmark", (0).toFixed(3));
      } else {
        let group_size_threshold_value
        if(payload.company_Size === 'Small'){
          group_size_threshold_value = 50000;
        }else if(payload.company_Size === 'Mid'){
          group_size_threshold_value = 150000;
        }else if(payload.company_Size === 'Large'){
          group_size_threshold_value = 300000;
        }else if(payload.company_Size === 'Jumbo'){
          group_size_threshold_value = 500000;
        }
        // let calculatedValue = parseFloat(
        //   (((res.data.assessment * Eligible_EEs_CT) / 1000) * res.data.risk) /
        //     (ISL_Pooling_Point / group_size_threshold_value)
        // ).toFixed(3);
        let calculatedValue = parseFloat((res.data.assessment * res.data.risk) / (ISL_Pooling_Point / group_size_threshold_value)).toFixed(3);
          set("IRMI_LC_Benchmark", calculatedValue);
          setSelectClientData((prev) => ({
            ...prev,
            IRMI_LC_Benchmark: calculatedValue,
          }));
      }
    });
  };

  const handleTrimValue = (e, setVal) => {
    let { name, value } = e.target;
    setVal(name, value.trimStart());
  };
  return (
    <div>
      {showForm && (
        <Formik
          validationSchema={schema}
          onSubmit={handleActions}
          initialValues={{
            Client_Name: !isAdd
              ? ""
              : client?.clientName
              ? client?.clientName
              : "",
            Client_ID: !isAdd ? 0 : client?.clientID ? client?.clientID : 0,
            hubLocalRegion: "",
            hubRegion: "",
            hubSuperRegion: "",
            Bill_Office: selectClientData?.Bill_Office
              ? selectClientData?.Bill_Office
              : "",
            Renewal_Date: selectClientData?.Renewal_Date
              ? moment(selectClientData?.Renewal_Date).format("yyyy-MM-DD")
              : "",
            zip:
            !isAdd ? "" : client && client?.clientZipCode
                ? client?.clientZipCode
                : selectClientData?.ClientZipCode
                ? selectClientData?.ClientZipCode
                : selectClientData?.Zip
                ? selectClientData?.Zip
                : "",
            Producer: selectClientData?.Producer
              ? selectClientData?.Producer
              : "",
          
            Eligible_EEs_CT: selectClientData?.Eligible_EEs_CT
              ? selectClientData?.Eligible_EEs_CT
              : "0",
            Enrolled_EEs_CT: selectClientData?.Enrolled_EEs_CT
              ? selectClientData?.Enrolled_EEs_CT
              : "0",
            Waived_EEs_CT: selectClientData?.Waived_EEs_CT
              ? selectClientData?.Waived_EEs_CT
              : "0",
            Enrolled_Mbrs_Ct: selectClientData?.Enrolled_Mbrs_Ct
              ? selectClientData?.Enrolled_Mbrs_Ct
              : "0",
            Group_Size: selectClientData?.Group_Size
              ? selectClientData?.Group_Size.split(" ")[0]
              : "Select Group Size",
            BenfitPointIndustry: client?.ahI_Industry
              ? client?.ahI_Industry
              : "",
            Industry: selectClientData?.Industry
              ? selectClientData?.Industry
              : "Select Industry",
            Main_Carriers: selectClientData?.Main_Carriers
              ? selectClientData?.Main_Carriers.split(",").map((item) => ({
                  value: item.toUpperCase(),
                  label: item.toUpperCase(),
                }))
              : [],
            
            Ex_Inflation_Rate: selectClientData?.Ex_Inflation_Rate
              ? selectClientData?.Ex_Inflation_Rate
              : "0",
            ISL_Pooling_Point: selectClientData?.ISL_Pooling_Point
              ? selectClientData?.ISL_Pooling_Point
              : "0",
            IRMI_LC_Benchmark: selectClientData?.IRMI_LC_Benchmark
              ? selectClientData?.IRMI_LC_Benchmark
              : "0",
            Funding_Arrangement: selectClientData?.Funding_Arrangement
              ? selectClientData?.Funding_Arrangement
              : "Select Funding Arrangement",
          
           
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            resetForm,
            values,
            touched,
            errors,
            setFieldValue,
          }) => (
            <>
              <Modal
                show={Boolean(showModal)}
                onHide={() => setShowModal(false)}
                animation
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div style={Fontstyling.modalHeading}>Warning</div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Please note that the $0 ISL or Pooling Point (PP) value may
                  not accurately reflect the true financial risk and impact
                  within the health plan(s). A $0 could underestimate the actual
                  exposure and alter the fair market value. To continue with a
                  $0 ISL / PP, select Confirm. Otherwise, select Cancel and use
                  the default value of $100,000 or a value of your choice.
                </Modal.Body>
                <Modal.Footer>
                  <button
                    style={Fontstyling.savebutton}
                    onClick={() => {
                      // setFieldValue("ISL_Pooling_Point", "0");
                      setConfirm(true);
                      handleSubmit();
                      setShowModal(false);
                    }}
                  >
                    Confirm
                  </button>
                  <button
                    style={Fontstyling.cancelbutton}
                    variant="secondary"
                    onClick={() => {
                      setShowModal(false);
                    }}
                  >
                    Cancel
                  </button>
                </Modal.Footer>
              </Modal>
              <Form id="form" onSubmit={handleSubmit}>
                <Row className="mb-2 gap-3">
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Client Name
                        <Required />
                      </Form.Label>
                      <Form.Control
                        name="Client_Name"
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        value={values.Client_Name}
                        onChange={(e) => {
                          // handleChange(e);
                          handleTrimValue(e, setFieldValue);
                        }}
                        onBlur={handleBlur}
                        disabled={isAdd}
                        isInvalid={touched.Client_Name && errors.Client_Name}
                        placeholder="Client Name"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.Client_Name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Client ID
                      </Form.Label>
                      <Form.Control
                        name="Client_ID"
                        type="text"
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        value={values.Client_ID}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled
                        placeholder="0"
                        isInvalid={touched.Client_ID && errors.Client_ID}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.Client_ID}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Renewal Date
                        <Required />
                      </Form.Label>
                      <Form.Control
                        name="Renewal_Date"
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        value={values.Renewal_Date}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isEdit && isAdd}
                        isInvalid={touched.Renewal_Date && errors.Renewal_Date}
                        type="date"
                        // placeholder="MEDC Type"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.Renewal_Date}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Main Office Zip Code
                        <Required />
                      </Form.Label>
                      <Form.Control
                        name="zip"
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        value={values.zip}
                        onChange={handleChange}
                        onBlur={(e) => {
                          handleBlur(e);
                          
                        }}
                        disabled={ isAdd ? client?.clientZipCode?true:isEdit :false}
                        isInvalid={touched.zip && errors.zip}
                        type="text"
                        placeholder="Main Office Zip Code*"
                        maxLength={15}
                        />
                      <Form.Control.Feedback type="invalid">
                        {errors.zip}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Producer/ Consultant Name
                      </Form.Label>
                      <Form.Control
                        name="Producer"
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        value={values.Producer}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isEdit && isAdd}
                        isInvalid={touched.Producer && errors.Producer}
                        type="text"
                        placeholder="Producer/ Consultant Name"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.Producer}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                {!isAdd && (
                  <Row className="mb-2 gap-3">
                    <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          HUB Super Region
                          <Required />
                        </Form.Label>
                        <Form.Select
                          className="rounded-0"
                          style={Fontstyling.dropdown_label}
                          name="hubSuperRegion"
                          value={values.hubSuperRegion}
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue("hubRegion", "");
                            setFieldValue("hubLocalRegion", "");
                          }}
                          onBlur={handleBlur}
                          //disabled
                          isInvalid={
                            values.hubSuperRegion === "Select hubSuperRegion" &&
                            touched.hubSuperRegion
                          }
                        >
                          <option value={"Select hubSuperRegion"}>
                            --Select HUB Super Region--
                          </option>
                          {[
                            ...new Set(
                              regionData
                                .filter(
                                  (el) => el.HubSuperRegion !== "NATIONAL"
                                )
                                .map((el) => el.HubSuperRegion)
                            ),
                          ]
                            .sort()
                            .map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          HUB Region
                          <Required />
                        </Form.Label>
                        <Form.Select
                          className="rounded-0"
                          style={Fontstyling.dropdown_label}
                          name="hubRegion"
                          value={values.hubRegion}
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue("hubLocalRegion", "");
                          }}
                          onBlur={handleBlur}
                          disabled={values.hubSuperRegion === ""}
                          isInvalid={
                            values.hubRegion === "Select hubRegion" &&
                            touched.hubRegion
                          }
                        >
                          <option value={"Select hubRegion"}>
                            --Select Hub Region--
                          </option>
                          {[
                            ...new Set(
                              regionData
                                .filter(
                                  (el) =>
                                    el.HubSuperRegion === values.hubSuperRegion
                                )
                                .map((el2) => el2.HubRegion)
                            ),
                          ]
                            .sort()
                            .map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          HUB Local Region
                          <Required />
                        </Form.Label>
                        <Form.Select
                          className="rounded-0"
                          style={Fontstyling.dropdown_label}
                          name="hubLocalRegion"
                          value={values.hubLocalRegion}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          disabled={values.hubRegion === ""}
                          isInvalid={
                            values.hubLocalRegion === "Select Local Region" &&
                            touched.hubLocalRegion
                          }
                        >
                          <option value={"Select Local Region"}>
                            --Select Local Region--
                          </option>
                          {regionData
                            .filter((el) => el.HubRegion === values.hubRegion)
                            .sort()
                            .map((item, index) => (
                              <option key={index} value={item.regionID}>
                                {item.HUBLocal}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                <Row className="mb-2 gap-3">
                </Row>
                <Row className="mb-2 gap-3">
                  {[
                    {
                      name: "Eligible_EEs_CT",
                      label: "# of Eligible Employees",
                    },
                    { name: "Waived_EEs_CT", label: "# of Waived Employees" },
                    {
                      name: "Enrolled_EEs_CT",
                      label: "# of Enrolled Employees",
                    },
                    {
                      name: "Enrolled_Mbrs_Ct",
                      label: "# of Enrolled Members",
                    },
                   
                  ].map((item, index) => (
                    <Col>
                      <CustomInputField
                        maxLength={item.name === "Eligible_EEs_CT" ? 5 : 8}
                        key={index}
                        label={item.label}
                        name={item.name}
                        value={values}
                        handleChange={(e) => {
                          handleChange(e)
                          if(item.name === "Enrolled_EEs_CT"){
                            let Members_CT = parseInt(2.7 * e.target.value)
                            setFieldValue("Enrolled_Mbrs_Ct",Members_CT)
                          }
                          else if(item.name === "Eligible_EEs_CT"){
                            let Enrolled_EE = parseInt(e.target.value) - parseInt(values['Waived_EEs_CT']);
                            let Members_CT = parseInt(2.7 * Enrolled_EE)
                            setFieldValue("Enrolled_EEs_CT",Enrolled_EE)
                            setFieldValue("Enrolled_Mbrs_Ct",Members_CT)
                          }
                          else if(item.name === "Waived_EEs_CT"){
                            let Enrolled_EE = parseInt(values['Eligible_EEs_CT']) - parseInt(e.target.value);
                            let Members_CT = parseInt(2.7 * Enrolled_EE)
                            setFieldValue("Enrolled_EEs_CT",Enrolled_EE)
                            setFieldValue("Enrolled_Mbrs_Ct",Members_CT)
                          }
                        }}
                        handleBlur={(e) => {
                          if (item.name === "Eligible_EEs_CT") {
                            if (
                              e.target.value !== "" &&
                              values.Industry !== "Select Industry" &&
                              values.Group_Size !== "Select Group Size" &&
                              values.ISL_Pooling_Point !== ""
                            ) {
                              let payload = {
                                id: 0,
                                industry: values.Industry,
                                company_Size: values.Group_Size,
                                assessment: 0,
                              };
                              setBenchMark(
                                payload,
                                setFieldValue,
                                values,
                                null
                              );
                            }
                          }
                          handleBlur(e);
                        }}
                        touched={touched}
                        errors={errors}
                        disabled={isEdit && isAdd || (item.name === "Enrolled_EEs_CT")}
                        isRequired={true}
                      />
                    </Col>
                  ))}
                </Row>
                <Row className="mb-2 gap-3">
                  {/* {[
                    {
                      name: "Enrolled_Kaiser_Mbrs_CT",
                      label: "# of Enrolled Kaiser Members",
                    },
                  ].map((item, index) => (
                    <Col>
                      <CustomInputField
                        maxLength={8}
                        key={index}
                        label={item.label}
                        name={item.name}
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        disabled={isEdit && isAdd}
                      />
                    </Col>
                  ))} */}
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Group Size
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.dropdown_label}
                        name="Group_Size"
                        value={values.Group_Size}
                        onChange={(e) => {
                          if (
                            values.Eligible_EEs_CT !== "" &&
                            values.Industry !== "Select Industry" &&
                            e.target.value !== "Select Group Size" &&
                            values.ISL_Pooling_Point !== ""
                          ) {
                            let payload = {
                              id: 0,
                              industry: values.Industry,
                              company_Size: e.target.value,
                              assessment: 0,
                            };
                            setBenchMark(payload, setFieldValue, values, null);
                          }
                          
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        disabled={isEdit && isAdd}
                        isInvalid={errors.Group_Size && touched.Group_Size}
                      >
                        <option value={"Select Group Size"}>
                          --Select Group Size--
                        </option>
                        {dropdownData.GroupSizeData.map((item) => (
                          <option
                            value={item.value}
                            key={item.CompanySizeID}
                            // selected={item.CompanySizeName.includes()}
                          >
                            {item.CompanySizeName}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.Group_Size}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>{" "}
                
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Industry
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.dropdown_label}
                        name="Industry"
                        value={values.Industry}
                        onChange={(e) => {
                          if (
                            values.Eligible_EEs_CT !== "" &&
                            e.target.value !== "Select Industry" &&
                            values.Group_Size !== "Select Group Size" &&
                            values.ISL_Pooling_Point !== ""
                          ) {
                            let payload = {
                              id: 0,
                              industry: e.target.value,
                              company_Size: values.Group_Size,
                              assessment: 0,
                            };
                            setBenchMark(payload, setFieldValue, values, null);
                          }
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        disabled={isEdit && isAdd}
                        isInvalid={
                          values.Industry === "Select Industry" &&
                          touched.Industry
                        }
                      >
                        <option value={"Select Industry"}>
                          --Select Industry--
                        </option>
                        {dropdownData.IndustryData.map((item, index) => (
                          <option
                            key={index}
                            value={item.industry}
                            // selected={values.Industry === item}
                          >
                            {item.industry}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.Industry}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-2 gap-3">
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Main Carriers
                        <Required />
                      </Form.Label>
                      <ReactSelect
                        name="Main_Carriers"
                        isDisabled={isEdit && isAdd}
                        isMulti
                        className="py-1 rounded-0"
                        options={dropdownData.carrierData}
                        value={values.Main_Carriers}
                        onChange={(selectedOption) => {
                          let event = {
                            target: {
                              name: "Main_Carriers",
                              value: selectedOption,
                            },
                          };
                          handleChange(event);
                        }}
                        onBlur={(e) => {
                          handleBlur(e);
                        }}
                        styles={{
                          control: (base, { isDisabled }) => ({
                            ...Fontstyling.primaryparagraph,
                            display: "flex",
                            alignItems: "center",
                            border:
                              errors.Main_Carriers && touched.Main_Carriers
                                ? "1px solid #dc3545"
                                : "1px solid #ced4da",
                            width: "auto",
                            // maxHeight: "35px",
                            height: "auto",
                            textAlign: "left",
                            backgroundColor: isDisabled ? "#e9ecef" : "",
                          }),
                          option: (
                            styles,
                            { data, isDisabled, isFocused, isSelected }
                          ) => {
                            return {
                              ...styles,
                              ...Fontstyling.primaryparagraph,
                              textAlign: "left",
                            };
                          },
                        }}
                      />
                      {errors.Main_Carriers && touched.Main_Carriers && (
                        <div
                          className="text-danger "
                          style={{
                            ...Fontstyling.errorlabel,
                            width: "100%",
                            fontSize: ".8em",
                            color: "#dc3545",
                          }}
                        >
                          {errors.Main_Carriers}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  {[
                    {
                      name: "ISL_Pooling_Point",
                      label: "ISL/ Pooling Point($)",
                      isRequired: true,
                    },
                  ].map((item, index) => (
                    <Col>
                      <CustomInputField
                        maxLength={15}
                        key={index}
                        label={item.label}
                        name={item.name}
                        value={values}
                        handleChange={handleChange}
                        handleBlur={(e) => {
                          if (item.name === "ISL_Pooling_Point") {
                            if (
                              values.Eligible_EEs_CT !== "" &&
                              values.Industry !== "Select Industry" &&
                              values.Group_Size !== "Select Group Size" &&
                              e.target.value !== ""
                            ) {
                              let payload = {
                                id: 0,
                                industry: values.Industry,
                                company_Size: values.Group_Size,
                                assessment: 0,
                              };
                              setBenchMark(
                                payload,
                                setFieldValue,
                                values,
                                null
                              );
                            }
                          }
                          handleBlur(e);
                        }}
                        touched={touched}
                        errors={errors}
                        disabled={isEdit && isAdd}
                        isRequired={item.isRequired}
                      />
                    </Col>
                  ))}
<Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Funding Arrangement
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.dropdown_label}
                        name="Funding_Arrangement"
                        value={values.Funding_Arrangement}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isEdit && isAdd}
                      >
                        <option value={"Select Funding Arrangement"}>
                          --Select Funding Arrangement--
                        </option>
                        {dropdownData.FundingArrangementData.map(
                          (item, index) => (
                            <option
                              key={index}
                              value={item.id}
                              // selected={values.Funding_Arrangement === item}
                            >
                              {item.funding_Arrangement}
                            </option>
                          )
                        )}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

               
                {!(isEdit && isAdd) && (
                  <div className="d-flex align-items-center" style={{marginTop:"30px"}}>
                    <button
                      type="submit"
                      className={"px-3 me-2 primary-button"}
                      style={Fontstyling.savebutton}
                    >
                      Save
                    </button>
                    <button
                      type="reset"
                      className={"px-3 secondary-button"}
                      onClick={() => {
                        if (!isAdd) {
                          setShowForm(false);
                        }
                        setSelectedClientValue({
                          value: client?.clientID ? client?.clientID : 0,
                          label: client?.clientName
                            ? client?.clientName
                            : "SELECT CLIENT NAME",
                        });
                        setIsEdit(true);
                        setIsAdd(true);
                        resetForm();
                        getClientData(client.clientID);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </Form>
            </>
          )}
        </Formik>
      )}
    </div>
  );
};

export default ClientDetail;
